<template>
  <div class="competeGroupsList">
    <!-- 表格 -->
    <el-card>
      <!-- 新增 -->
      <el-button type="primary" slot="header" @click="onAdd">{{$t('lang.btn_add')}}</el-button>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{$t('lang.btn_delete')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 组别 -->
        <el-table-column prop="groupName" :label="$t('lang.lab_competeGroup')" :sortable="'custom'"></el-table-column>
        <!-- 性别限制 -->
        <el-table-column prop="genderLimit" :label="$t('lang.lab_genderLimit')" :sortable="'custom'">
          <template slot-scope="scope">
            <!-- 0: 女 -->
            <span v-if="scope.row.genderLimit == 0">{{$t('lang.Group_gender[1].name')}}</span>
            <!-- 1: 男 -->
            <span v-if="scope.row.genderLimit == 1">{{$t('lang.Group_gender[2].name')}}</span>
            <!-- 2: 不限制 -->
            <span v-if="scope.row.genderLimit == 2">{{$t('lang.Group_gender[3].name')}}</span>
             <!-- 2: 等比例混合 -->
            <span v-if="scope.row.genderLimit == 3">{{$t('lang.Group_gender[4].name')}}</span>
             <!-- 2: 非等比例混合 -->
            <span v-if="scope.row.genderLimit == 4">{{$t('lang.Group_gender[5].name')}}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)">{{$t('lang.btn_edit')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 新增编辑 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="600px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px" label-suffix=":">
        <!-- 组别 -->
        <el-form-item prop="groupName" :label="$t('lang.lab_competeGroup')">
          <input style="display: none"/>
          <el-input v-model="form.groupName" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_competeGroup')" maxlength="20"></el-input>
        </el-form-item>
        <!-- 性别限制 -->
        <el-form-item prop="genderLimit" :label="$t('lang.lab_genderLimit')">
          <el-select v-model="form.genderLimit" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_genderLimit')">
            <el-option
              v-for="(item,index) in genders"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="toCancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="toSave('form')" :disabled="isDisabled">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog> 
  </div>
</template>

<script>
/**
 *@ClassName:competeGroupsList
 *@Description:组别管理
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-16
 */
export default {
  name: '',
  components: {},
  data() {
    return {
      isShow: false, // 新增编辑dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_add'), // 新增编辑dialog的title
      isDisabled: true, // 确定按钮置灰
      /* 组别管理列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      total: 0, // 数据总数
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 列表数据
      /* 组别管理详情(新建编辑)变量 */
      rules: {
        groupName: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_competeGroup'), trigger: 'blur' }],
        genderLimit: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_genderLimit'), trigger: 'change' }],
      },
      genders: this.$i18n.t('lang.Group_gender'), // 性别限制下拉list
      form: {
        id: '',
        groupName: '',
        genderLimit: '',
      }, // 详细数据
    }
  },
  computed: {},
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取组别管理列表数据
    getData() {
      this.$get(`/itemGroup/itemGroup?pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 查询
    onSearch(flag) { 
      if (flag) {
        this.pageNum = 1
      }
      this.$get(`/itemGroup/itemGroup?sortName=${this.sortName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 新增
    onAdd() {
      console.log('onAdd')
      this.isTitle = this.$i18n.t('lang.btn_add')
      this.form.id = ''
      this.form.eventName = ''
      this.form.isRelay = ''
      this.form.numLimit = ''
      this.isShow = true
    },
    // 删除
    onDelete() {
      console.log('onDelete')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return        
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/itemGroup/group/${array}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_delSuccess')
                })
                // 更新tableData
                this.onSearch(true)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })  
    },
    // 编辑
    onEdit(data) {
      console.log('onEdit', data)
      this.isTitle = this.$i18n.t('lang.btn_edit')
      this.form.id = data.id
      this.form.groupName = data.groupName
      this.form.genderLimit = data.genderLimit
      // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
      this.saveData = JSON.stringify(this.form)
      this.isShow = true
    },
    // 保存
    toSave(formName) {
      console.log('toSave')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.form
          this.$postJson('/itemGroup/group', params).then(
            res => {
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_modifySuccess')
                })
                this.handleDialogClosed()
                // 更新tableData
                this.onSearch(true)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 取消
    toCancel() {
      console.log('toCancel')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.groupName = ''
      this.form.genderLimit = ''
    },
    // 监听关闭'新建编辑'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.groupName = ''
      this.form.genderLimit = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true)
    },
  },
  created() {
    this.getData()
  },
  mounted() {}
}
</script>

<style lang='scss'>
</style>
